import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export type DurationCallRequest = {totalDuration: number, numberOfCalls: number}
@Injectable({
  providedIn: 'root',
})
export class CallDurationService {
  private readonly baseUrl = environment.ntIntegrationApiUrl;
  constructor(private http: HttpClient) {
  }

  public getCallDurationForPeriod(start: Date, end: Date): Observable<DurationCallRequest> {
    const dayAfterEndDate = new Date(end);
    dayAfterEndDate.setDate(dayAfterEndDate.getDate() + 1);
    return this.http.get<DurationCallRequest>(
      `${this.baseUrl}/call-duration-for-period?start=${this.formatToIsoString(start)}&end=${this.formatToIsoString(dayAfterEndDate)}`
      );
  }

  private formatToIsoString(date: Date): string {
    const day = (date.getDate() < 10 ? '0' : '') + date.getDate();
    const month = (date.getMonth() + 1 < 10 ? '0' : '') + (date.getMonth() + 1);
    const year = date.getFullYear();
    return `${year}-${month}-${day}T00:00:00Z`;
  }
}
